// extracted by mini-css-extract-plugin
module.exports = {"Selected":"CategoryItem_Selected__2Zdgq"};